import { ReactNode, memo, useContext } from 'react';
import styled from '@emotion/styled';
import { mediaMax, zIndex } from 'presentations/views/styles';
import { white } from 'presentations/views/styles/color';
import {
  AllDayTimeGridView,
  CalendarView,
  MonthWeekdayHeaderView,
  WeekdayHeaderView,
} from 'presentations/views/components/atoms/Calendar';
import { useDashboardCalendar } from './hooks';
import { ViewerItem } from 'presentations/api/schema/user';
import { MergeableEventListItem, Schedule } from '../../atoms/Calendar/reducer';
import { ProjectEventListItem } from 'presentations/api/schema/project/project_event';
import { CalendarContext } from '../../atoms/Calendar/reducer/CalendarContext';
import MonthGridList from 'presentations/views/components/atoms/Calendar/MonthGridList';
import DayTimeGridList from 'presentations/views/components/atoms/Calendar/DayTimeGridList';
import { DateTime } from 'infras/datetime';

export interface Props {
  viewer?: ViewerItem;
  onClickEvent: (event: MergeableEventListItem, element: HTMLElement) => void;
  onClickMoreEvent?: (date: DateTime, el: HTMLElement) => void;
  onClickDay?: (date: DateTime, el: HTMLElement) => void;
  onUpdateSchedule?: (schedule: Schedule) => void;
  onClickAddTimeZone?: (el: HTMLElement) => void;
  onClickTimeZone?: (timeZone: string, el: HTMLElement) => void;
  events: ProjectEventListItem[];
  isLoading?: boolean;
  selectedEventId?: string;
  header?: ReactNode;
}

const Component = memo((props: Props) => {
  const { state, dispatch } = useContext(CalendarContext);
  useDashboardCalendar({
    viewer: props.viewer,
    events: props.events,
    isLoading: props.isLoading,
  });

  return state.showRange.month ? (
    <MonthContainer>
      <Header>
        {props.header}
        <MonthWeekdayHeaderView />
      </Header>
      <MonthGridList
        onClickEvent={props.onClickEvent}
        onClickMoreEvent={props.onClickMoreEvent}
        onClickDay={props.onClickDay}
        onUpdateSchedule={props.onUpdateSchedule}
        selectedEventId={props.selectedEventId}
      />
    </MonthContainer>
  ) : (
    <DayTimeContainer>
      <Header>
        {props.header}
        <WeekdayHeaderView
          onClickAddTimeZone={props.onClickAddTimeZone}
          onClickTimeZone={props.onClickTimeZone}
        />
        <AllDayTimeGridView
          onClickEvent={props.onClickEvent}
          onUpdateSchedule={props.onUpdateSchedule}
          selectedEventId={props.selectedEventId}
        />
      </Header>
      <DayTimeGridList
        onClickEvent={props.onClickEvent}
        selectedEventId={props.selectedEventId}
        onUpdateSchedule={props.onUpdateSchedule}
      />
    </DayTimeContainer>
  );
});
const Header = styled.div`
  position: sticky;
  z-index: ${zIndex(1100)};
  top: 0;
  background-color: ${white};
`;

const DayTimeContainer = styled(CalendarView)`
  background-color: ${white};
  width: 100%;
  height: inherit;
  ${mediaMax.tablet} {
    width: 100vw;
  }
`;
const MonthContainer = styled(CalendarView)`
  background-color: ${white};
  width: 100%;
  height: inherit;
  ${mediaMax.tablet} {
    width: 100vw;
  }
`;
export default Component;
